import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { globalServices } from "../../Services/global.service";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { validationService } from "../../Services/validation.service";
import { numbersOnly, ibanNum, lettersOnly, OIB } from "../../Config/Regex";
import Tooltip from "../Common/Tooltip";

const TenantData = (props) => {
  const goTo = (data) => {
    setCreateTenantData({
      taxNumber: data.taxNumber,
      name: data.name,
      code: data.code,
      owner: data.owner,
      iban: data.iban != "" ? "HR" + data.iban : "",
      street: data.street,
      streetNumber: data.streetNumber,
      streetNumberExtension: data.streetNumberExtension,
      postalNumber: data.postalNumber.value,
      city: data.city,
      countryId: Number(data.countryId),
      taxObligation: Number(data.taxObligation),
      taxNote: data.taxNote,
      image: createTenantData.image ? createTenantData.image : data.image,
      fiscalObligation: Boolean(data.fiscalObligation),
      accountingActive: Boolean(data.accountingActive),
      //accountingActive: false,
    });
    props.nextStep();
  };

  const history = useHistory();
  const {
    createTenantData,
    setCreateTenantData,
    removeLogo,
    setRemoveLogo,
    logoPreview,
    setLogoPreview,
  } = props;
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { createTenantData },
  });
  const { t: translator } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [postOffices, setPostOffices] = useState([]);

  useEffect(() => {
    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const getCity = (id, label) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        setValue("city", res.data.data.name, { shouldValidate: true });
      })
      .catch(() => history.push("/Error"));
  };

  const checkIsImage = (inputFile) => {
    if (!inputFile) return true;
    if (inputFile.type !== "image/jpeg") return false;
    return loadImage(inputFile)
      .then((res) => {
        if (res.width <= 400 && res.height <= 200) {
          document.getElementsByName("image")[0].files =
            document.getElementsByName("image1")[0].files;
          setLogoPreview(res.src);
        } else setRemoveLogo(true);
        return res.width <= 400 && res.height <= 200 ? true : false;
      })
      .catch((err) => console.log(err));
  };

  async function loadImage(uploadedFile) {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = function () {
        resolve({ width: img.width, height: img.height, src: img.src });
      };
      img.src = window.URL.createObjectURL(uploadedFile);
    });
  }

  const handleRemoveLogo = () => {
    setLogoPreview("");
    setValue("image1", null);
    setValue("image", null, { shouldValidate: true });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-TenantData-Main-Data")}
            </legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="taxNumber">
                  {translator("Onboarding-TenantData-TaxNumber")}
                </label>{" "}
                <Tooltip text={translator("TenantDataTaxNumber-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="taxNumber"
                  ref={register({
                    required: true,
                    pattern: OIB,
                    validate: () =>
                      validationService.validateTenantOib(
                        document.getElementsByName("taxNumber")[0].value
                      ),
                  })}
                  defaultValue={createTenantData.taxNumber}
                />
                {errors.taxNumber && errors.taxNumber.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.taxNumber && errors.taxNumber.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBNotValid")}
                  </p>
                )}
                {errors.taxNumber && errors.taxNumber.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-OIBLength")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="tenantName">
                  {translator("Onboarding-TenantData-Name")}
                </label>{" "}
                <Tooltip text={translator("TenantDataName-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  ref={register({ required: true, maxLength: 250 })}
                  defaultValue={createTenantData.name}
                />
                {errors.name && errors.name.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.name && errors.name.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="code">
                  {translator("Onboarding-TenantData-Password")}
                </label>{" "}
                <Tooltip text={translator("TenantDataPassword-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  ref={register({
                    required: true,
                    maxLength: 20,
                    validate: () =>
                      validationService.validateCode(
                        document.getElementsByName("code")[0].value
                      ),
                  })}
                  defaultValue={createTenantData.code}
                />
                {errors.code && errors.code.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.code && errors.code.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Tenant-Code")}
                  </p>
                )}
                {errors.code && errors.code.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength20")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="owner">
                  {translator("Onboarding-TenantData-Owner")}
                </label>{" "}
                <Tooltip text={translator("TenantDataOwner-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="owner"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: lettersOnly,
                  })}
                  defaultValue={createTenantData.owner}
                />
                {errors.owner && errors.owner.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.owner && errors.owner.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
                {errors.owner && errors.owner.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="iban">
                  {translator("Onboarding-TenantData-Iban")}
                </label>{" "}
                <Tooltip text={translator("TenantDataIban-Msg")} />
                <div class="input-group mb-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      HR
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="iban"
                    ref={register({
                      //required: true,
                      pattern: ibanNum,
                    })}
                    defaultValue={createTenantData.iban.substring(2)}
                  />
                </div>
                {/* {errors.iban && errors.iban.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )} */}
                {errors.iban && errors.iban.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-IBAN")}
                  </p>
                )}
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-TenantData-AddressInformation")}
            </legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="street">
                  {translator("Onboarding-TenantData-Street")}
                </label>{" "}
                <Tooltip text={translator("TenantDataStreet-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="street"
                  ref={register({
                    required: true,
                    pattern: lettersOnly,
                    maxLength: 150,
                  })}
                  defaultValue={createTenantData.street}
                />
                {errors.street && errors.street.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.street && errors.street.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
                {errors.street && errors.street.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength150")}
                  </p>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-8">
                  <label htmlFor="streetNumber">
                    {translator("Onboarding-TenantData-StreetNumber")}
                  </label>{" "}
                  <Tooltip text={translator("TenantDataStreetNumber-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumber"
                    ref={register({
                      required: true,
                      pattern: numbersOnly,
                      maxLength: 6,
                    })}
                    defaultValue={createTenantData.streetNumber}
                  />
                  {errors.streetNumber &&
                    errors.streetNumber.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength6")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}!
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="streetNumberExtension">
                    {translator("Onboarding-TenantData-AdditionOfStreetNumber")}
                  </label>{" "}
                  <Tooltip
                    text={translator("TenantDataStreetNumberAddition-Msg")}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumberExtension"
                    ref={register({ maxLength: 10 })}
                    defaultValue={createTenantData.streetNumberExtension}
                  />
                  {errors.streetNumberExtension &&
                    errors.streetNumberExtension.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-5 col-xs-12">
                  <label htmlFor="postalNumber">
                    {translator("Onboarding-TenantData-ZipCode")}
                  </label>{" "}
                  <Tooltip text={translator("TenantDataZipCode-Msg")} />
                  {postOffices.length != 0 && (
                    <Controller
                      as={Select}
                      options={
                        postOffices &&
                        postOffices.map((p) => ({
                          id: p.id,
                          label: p.name,
                          value: p.name,
                        }))
                      }
                      name="postalNumber"
                      defaultValue={{
                        label: createTenantData.postalNumber,
                        value: createTenantData.postalNumber,
                      }}
                      control={control}
                      rules={{ required: true }}
                      onChange={function (event) {
                        getCity(event[0].id, event[0].label);

                        return event[0];
                      }}
                    />
                  )}
                  {errors.city && errors.city.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-7 col-xs-12">
                  <label htmlFor="city">
                    {translator("Onboarding-TenantData-City")}
                  </label>{" "}
                  <Tooltip text={translator("TenantDataCity-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    ref={register({ required: true })}
                    defaultValue={createTenantData.city}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="countryId">
                  {translator("Onboarding-TenantData-State")}
                </label>
                {countries.length > 0 && (
                  <select
                    className="form-control"
                    name="countryId"
                    ref={register({ required: true })}
                    defaultValue={createTenantData.countryId}
                  >
                    {countries.map((e, key) => {
                      return (
                        <option selected={true} key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                )}
                {errors.countryId && errors.countryId.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-TenantData-MoreInformation")}
            </legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="taxObligation">
                  {translator("Onboarding-TenantData-TaxLiability")}
                </label>{" "}
                <Tooltip text={translator("TenantDataTaxLiability-Msg")} />
                <select
                  className="form-control"
                  name="taxObligation"
                  ref={register({ required: true })}
                  defaultValue={createTenantData.taxObligation}
                >
                  <option value={1}>
                    {translator("Onboarding-TenantData-TaxLiabilitySelect-Yes")}
                  </option>
                  <option value={0}>
                    {translator("Onboarding-TenantData-TaxLiabilitySelect-No")}
                  </option>
                </select>
                {errors.taxObligation &&
                  errors.taxObligation.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label htmlFor="taxNote">
                  {translator("Onboarding-TenantData-TaxNote")}
                </label>{" "}
                <Tooltip text={translator("TenantDataTaxNote-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="taxNote"
                  ref={register({ maxLength: 250 })}
                  defaultValue={createTenantData.taxNote}
                />
                {errors.taxNote && errors.taxNote.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="fiscalObligation"
                    ref={register}
                    defaultChecked={createTenantData.fiscalObligation}
                    onChange={() =>
                      setCreateTenantData({
                        ...createTenantData,
                        fiscalObligation: !createTenantData.fiscalObligation,
                      })
                    }
                  />
                  <span className="checkmark"></span>
                </label>
                <span>
                  {translator("Onboarding-TenantData-FiscalObligation")}?
                </span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="accountingActive"
                    ref={register}
                    defaultChecked={createTenantData.accountingActive}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("Onboarding-TenantData-IsAccounting")}</span>
              </div>

              <div
                className="form-group"
                style={{ display: logoPreview === "" ? "block" : "none" }}
              >
                <label>{translator("Onboarding-Tenant-Image")}</label>{" "}
                <Tooltip text={translator("TenantDataLogo-Msg")} />
                <input
                  className="form-control-file"
                  type="file"
                  name="image1"
                  ref={register({
                    required: false,
                    validate: () => {
                      return checkIsImage(
                        document.getElementsByName("image1")[0].files[0]
                      );
                    },
                  })}
                />
                {errors.image1 && errors.image1.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-ImageJpg")}
                  </p>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  {logoPreview !== "" && (
                    <img
                      src={logoPreview}
                      alt="logoPreview"
                      className="logoPreview"
                    />
                  )}
                </div>
                <input type="file" name="image" ref={register} hidden />
                <div className="form-group col-md-4">
                  {logoPreview !== "" && (
                    <>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handleRemoveLogo}
                      >
                        <i className="fas fa-trash-alt text-secondary"></i>
                      </button>
                      &nbsp;<span>{translator("Remove-Logo")}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="text-right">
        <button className="btn btn-primary" onClick={handleSubmit(goTo)}>
          {translator("Onboarding-Btn-Next")}
        </button>
      </div>
    </>
  );
};

export default TenantData;
